<template>
  <div
    class="flex items-end"
  >
    <h1
      m="r-4"
    >
      Vue Dialog
    </h1>

    <a
      m="r-2"
      href="https://www.npmjs.com/package/gitart-vue-dialog"
      target="_blank"
    >
      npm
    </a>

    <a
      m="r-2"
      href="https://github.com/MichaelGitArt/gitart-vue-dialog"
      target="_blank"
    >
      github
    </a>

    <a
      href="https://gitart-vue-dialog.netlify.app"
      target="_blank"
    >
      docs
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TheHeader',
})
</script>
